import type { GuessProblem } from '../../../../shared/daily-word';
import type { dailyWord as en } from '../en/daily-word';

const problems: Readonly<Record<GuessProblem, string>> = {
  tooShort: '字母不够',
  notAWord: '词库里没有这个词',
  alreadyGuessed: '已经猜过了',
};

export const dailyWord: typeof en = {
  problem: (problem) => problems[problem],
  guessFailed: '猜词没能送达房间，请再试一次。',
  foundChat: '你猜中了。揭晓答案后才能聊天。',
  chatPlaceholder: '说点什么…',
  wordOf: (round, rounds) => `第 ${round} / ${rounds} 个单词`,
  gameOver: '游戏结束',
  gameEnded: '游戏已中止',
  waitingRoom: '等待室',
  wordsDetail: (words) => `${words} 个单词。`,
  wordsFound: (words) => `猜中 ${words} 个单词`,
  alone: '叫上好友更好玩。',
  setup: (players, words) =>
    `${players} 人，${words} 个单词。所有人同时猜同一个词，次数越少得分越高。`,
  guestSetup: (players, words) => `${players} 人，${words} 个单词。`,
  foundWatch: '你猜中了。等其他人猜完，一起揭晓。',
  outWatch: '次数用完了。等其他人猜完，一起揭晓。',
  others: '其他玩家',
  everyone: '所有玩家',
  everyoneGuessing: '大家正在猜单词',
  nobodyFound: '没有人猜中',
  marksOnly: '只看标记，不显示字母',
  foundPoints: (points) => `猜中 · +${points}`,
  outOfGuesses: '次数用完了',
  noGuesses: '还没猜过',
  guessesCount: (count) => `猜了 ${count} 次`,
  wordResults: (round) => `第 ${round} 个单词的结果`,
  wordWas: (word) => `答案是 ${word}。`,
  foundInPoints: (guesses, points) => `${guesses} 次猜中 · +${points}`,
  missed: '未猜中',
  paused: '已暂停',
  wordWasLabel: '答案是',
  youFound: (guesses, points) => `你用 ${guesses} 次猜中，获得 +${points} 分`,
  youMissed: '这次没有猜中',
  nextWord: '下一个单词',
  finalScores: '最终得分',
  gotIt: (guesses, points) => `${guesses} 次猜中！+${points}`,
  waitingCount: (count) => `正在等 ${count} 位玩家`,
  everyoneDone: '所有人都猜完了',
  toGuess: '猜词时间',
  findWord: '猜出单词',
  foundCount: (count) => `${count} 人猜中了`,
  fewerScore: '次数越少，得分越高',
  away: '暂离',
  waiting: '等待中',
  foundItPoints: (points) => `猜中 · +${points}`,
  guessing: '猜词中',
  yourGuesses: '你的猜词',
  rowLetter: (letter, mark) => `${letter} ${mark}`,
  row: (word, letters) => `${word}：${letters.join('，')}。`,
  legend: {
    correct: '字母和位置都正确',
    present: '在单词中，但位置不对',
    absent: '不在单词中',
  },
  legendLine: '绿色：位置正确。珊瑚色：在别处。',
  freshPrompt: '输入一个 5 字母英文单词，按回车确认。',
  nextPrompt: '回车检查单词，退格删除字母。',
  wordNumber: (puzzle) => `单词 #${puzzle}`,
  today: '今日单词',
  dailyFresh: '可以猜 6 次，每天一个新词。',
  readIt: '怎么看标记',
  shareDaily: (puzzle) => `每日单词 #${puzzle}`,
  foundIn: (guesses) => `${guesses} 次猜中。`,
  notThisTime: '这次没有猜中。',
  dailyFound: (word, streak) => `答案是 ${word}。${streak}`,
  dailyMissed: '明天重新开始连胜。',
  guesses: '猜词次数',
  guessesOf: (count, max) => `${count} / ${max}`,
  nextWordIn: '距下一个单词',
  share: '分享',
  practiceWord: '练习单词',
  guessesToFind: '猜中次数分布',
  streak: (days) => (days > 1 ? `已连续猜中 ${days} 天。` : '连胜开始了。'),
  challenge: '挑战',
  practice: '练习',
  friendWord: '好友的单词',
  challengeFresh: '好友发来了这个词，可以猜 6 次。',
  practiceFresh: '可以猜 6 次，练习不计入统计。',
  sharePractice: '每日单词练习',
  practiceResult: (word) => `答案是 ${word}。练习不计入统计。`,
  practiceMissed: '练习不计入统计。',
  anotherWord: '再来一个词',
  challengeFriend: '挑战好友',
  todayWord: '今日单词',
  youFoundWord: (word) => `你猜出了 ${word}`,
  newWordAtMidnight: '午夜换新词。',
  friendFewer: (guesses) =>
    `好友会猜同一个词，试着用少于 ${guesses} 次猜中。他们只能看到你的标记，看不到字母。`,
  friendSame: '好友会猜同一个词。他们只能看到你的标记，看不到字母。',
  yourMarks: '你的标记',
  onDevice: '本机记录',
  stats: {
    played: '已玩',
    found: '猜中率',
    currentStreak: '当前连胜',
    bestStreak: '最长连胜',
  },
  copied: '已复制',
  guessNumber: (guess, max) => `第 ${guess} / ${max} 次猜词`,
  fixRow: '修改这一行，再试一次',
  lettersPlaced: (letters, _count) => `${letters} 位置正确`,
  lettersElsewhere: (letters, _count) => `${letters} 在单词的其他位置`,
  known: (parts) => (parts.length ? parts.join('，') : '这些字母都不在单词中'),
  distribution: (count, guesses) => `${count} 个单词用 ${guesses} 次猜中`,
};
